module.exports = __webpack_public_path__ + "img/face-1.99e58416.jpg";